import React, { useState } from "react";
import { Button } from "src/components/ui/button";
import { useLanguage } from "src/context/LanguageContext";
import { motion, AnimatePresence } from "framer-motion";
import DrawerAddContent from "./DrawerAddContent";
import DialogDeleteContent from "./DialogDeleteContent";
import DrawerEditContent from "./DrawerEditContent";
import { SubLessonData } from "../../../../../lib/languages";
import { useAuth } from "../../../../../context/AuthContext";

const PlayerSVG = (
  <svg
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_478_1440)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.5 30.5H7.5C5.5109 30.4999 3.6033 29.7097 2.1968 28.3032C0.790291 26.8967 8.70173e-05 24.9891 0 23L0 8C8.70173e-05 6.0109 0.790291 4.1033 2.1968 2.6968C3.6033 1.29029 5.5109 0.500087 7.5 0.5L22.5 0.5C24.4891 0.5 26.3968 1.29018 27.8033 2.6967C29.2098 4.10322 30 6.01088 30 8V23C30 24.9891 29.2098 26.8968 27.8033 28.3033C26.3968 29.7098 24.4891 30.5 22.5 30.5Z"
        fill="#2A61E1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.0625 8.9375H22.5C23.5815 8.93743 24.6217 8.52203 25.4058 7.77707C26.1899 7.03211 26.6579 6.01449 26.7132 4.93438C26.7686 3.85426 26.407 2.79414 25.7032 1.97294C24.9994 1.15174 24.0071 0.632179 22.9312 0.521562C22.7878 0.513594 22.6458 0.5 22.5 0.5H7.5C5.5109 0.500087 3.6033 1.29029 2.1968 2.6968C0.790291 4.1033 8.70173e-05 6.0109 0 8L0 23C8.70205e-05 19.2704 1.4817 15.6936 4.11891 13.0564C6.75612 10.4192 10.3329 8.93759 14.0625 8.9375Z"
        fill="#039BF0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.5 15.5C21.0166 15.5 19.5666 15.9399 18.3332 16.764C17.0999 17.5881 16.1386 18.7594 15.5709 20.1299C15.0032 21.5003 14.8547 23.0083 15.1441 24.4632C15.4335 25.918 16.1478 27.2544 17.1967 28.3033C18.2456 29.3522 19.582 30.0665 21.0368 30.3559C22.4917 30.6453 23.9997 30.4968 25.3701 29.9291C26.7406 29.3614 27.9119 28.4001 28.736 27.1668C29.5601 25.9334 30 24.4834 30 23V8C30 9.98912 29.2098 11.8968 27.8033 13.3033C26.3968 14.7098 24.4891 15.5 22.5 15.5Z"
        fill="#1E4CB7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.7413 8.87947C11.5992 8.79199 11.4364 8.744 11.2697 8.74045C11.1029 8.7369 10.9382 8.77792 10.7926 8.85928C10.647 8.94064 10.5257 9.05939 10.4413 9.20327C10.3569 9.34715 10.3124 9.51095 10.3125 9.67775V21.3224C10.3124 21.4892 10.3569 21.653 10.4413 21.7969C10.5257 21.9408 10.647 22.0596 10.7926 22.1409C10.9382 22.2223 11.1029 22.2633 11.2697 22.2597C11.4364 22.2562 11.5992 22.2082 11.7413 22.1207C14.1314 20.6503 18.9033 17.7135 21.2025 16.2984C21.3389 16.2145 21.4515 16.0971 21.5296 15.9574C21.6077 15.8176 21.6488 15.6602 21.6488 15.5001C21.6488 15.34 21.6077 15.1826 21.5296 15.0428C21.4515 14.9031 21.3389 14.7857 21.2025 14.7018C18.9033 13.2867 14.1314 10.3499 11.7413 8.87947Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_478_1440">
        <rect
          width="30"
          height="30"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
const LiveSvg = (
  <svg
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30 19.7188C30 17.9066 28.379 16.4375 26.3793 16.4375H3.62069C1.62103 16.4375 0 17.9066 0 19.7188V27.2188C0 29.0309 1.62103 30.5 3.62069 30.5H26.3793C28.379 30.5 30 29.0309 30 27.2188V19.7188Z"
      fill="#F51E1E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.6907 23V21.5938H22.7597C23.0452 21.5938 23.2769 21.3838 23.2769 21.125C23.2769 20.8663 23.0452 20.6562 22.7597 20.6562H20.1735C19.888 20.6562 19.6562 20.8663 19.6562 21.125V25.8125C19.6562 26.0712 19.888 26.2812 20.1735 26.2812H22.7597C23.0452 26.2812 23.2769 26.0712 23.2769 25.8125C23.2769 25.5538 23.0452 25.3438 22.7597 25.3438H20.6907V23.9375H22.7597C23.0452 23.9375 23.2769 23.7275 23.2769 23.4688C23.2769 23.21 23.0452 23 22.7597 23H20.6907Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4134 25.8125V21.125C12.4134 20.8663 12.1817 20.6562 11.8961 20.6562C11.6106 20.6562 11.3789 20.8663 11.3789 21.125V25.8125C11.3789 26.0712 11.6106 26.2812 11.8961 26.2812C12.1817 26.2812 12.4134 26.0712 12.4134 25.8125Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.20703 21.125V25.8125C6.20703 26.0712 6.43876 26.2812 6.72427 26.2812H9.31048C9.596 26.2812 9.82772 26.0712 9.82772 25.8125C9.82772 25.5538 9.596 25.3438 9.31048 25.3438H7.24151V21.125C7.24151 20.8663 7.00979 20.6562 6.72427 20.6562C6.43876 20.6562 6.20703 20.8663 6.20703 21.125Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.092 20.9905L16.0358 24.1813L14.9796 20.9905C14.8974 20.7426 14.6088 20.6019 14.3357 20.676C14.0621 20.7505 13.9069 21.0121 13.9886 21.2596L15.5403 25.9471C15.606 26.1454 15.8072 26.2813 16.0358 26.2813C16.2645 26.2813 16.4657 26.1454 16.5314 25.9471L18.0831 21.2596C18.1648 21.0121 18.0096 20.7505 17.736 20.676C17.4629 20.6019 17.1743 20.7426 17.092 20.9905Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.8595 1.35913C22.23 2.78741 23.7936 5.22913 23.7936 7.99991C23.7936 10.7707 22.23 13.2124 19.8595 14.6407C19.6221 14.7841 19.5574 15.0752 19.7152 15.2908C19.8735 15.506 20.1947 15.5646 20.4326 15.4216C23.0814 13.8255 24.8281 11.096 24.8281 7.99991C24.8281 4.90382 23.0814 2.17429 20.4326 0.578193C20.1947 0.435224 19.8735 0.493818 19.7152 0.708974C19.5574 0.924599 19.6221 1.21569 19.8595 1.35913Z"
      fill="#F51E1E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.56934 0.578193C6.92055 2.17429 5.17383 4.90382 5.17383 7.99991C5.17383 11.096 6.92055 13.8255 9.56934 15.4216C9.80727 15.5646 10.1285 15.506 10.2868 15.2908C10.4445 15.0752 10.3799 14.7841 10.1425 14.6407C7.77194 13.2124 6.20831 10.7707 6.20831 7.99991C6.20831 5.22913 7.77194 2.78741 10.1425 1.35913C10.3799 1.21569 10.4445 0.924599 10.2868 0.708974C10.1285 0.493818 9.80727 0.435224 9.56934 0.578193Z"
      fill="#F51E1E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.1427 3.70288C19.6768 4.62679 20.6886 6.20694 20.6886 7.99991C20.6886 9.79288 19.6768 11.373 18.1427 12.2969C17.9053 12.4404 17.8406 12.7315 17.9984 12.9471C18.1567 13.1623 18.4779 13.2208 18.7158 13.0779C20.5277 11.9857 21.723 10.1182 21.723 7.99991C21.723 5.88163 20.5277 4.01413 18.7158 2.92194C18.4779 2.77897 18.1567 2.83757 17.9984 3.05272C17.8406 3.26835 17.9053 3.55944 18.1427 3.70288Z"
      fill="#F51E1E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2826 2.92194C9.47075 4.01413 8.27539 5.88163 8.27539 7.99991C8.27539 10.1182 9.47075 11.9857 11.2826 13.0779C11.5206 13.2208 11.8418 13.1623 12 12.9471C12.1578 12.7315 12.0931 12.4404 11.8557 12.2969C10.3216 11.373 9.30987 9.79288 9.30987 7.99991C9.30987 6.20694 10.3216 4.62679 11.8557 3.70288C12.0931 3.55944 12.1578 3.26835 12 3.05272C11.8418 2.83757 11.5206 2.77897 11.2826 2.92194Z"
      fill="#F51E1E"
    />
    <path
      d="M14.9999 10.8125C16.7139 10.8125 18.1034 9.5533 18.1034 8C18.1034 6.4467 16.7139 5.1875 14.9999 5.1875C13.2859 5.1875 11.8965 6.4467 11.8965 8C11.8965 9.5533 13.2859 10.8125 14.9999 10.8125Z"
      fill="#F51E1E"
    />
  </svg>
);

export default function ContentTab({
  setVideoData,
  loading,
  contents,
  fetchContents,
}) {
  const { user } = useAuth();
  const isTeacher = user?.role === "teacher";

  const { language } = useLanguage();
  const [hoveredCard, setHoveredCard] = useState(null);
  const t = SubLessonData[language] || SubLessonData["en"];

  if (!loading && contents.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 p-8">
        {PlayerSVG}
        <p className="text-lg text-muted-foreground">{t.noContentMessage}</p>
        {isTeacher && <DrawerAddContent fetchContents={fetchContents} />}
      </div>
    );
  }

  return (
    <div className="grid gap-4">
      {contents.map((content) => (
        <div
          key={content.id}
          className="flex items-center justify-between py-4 border-b relative"
          onMouseEnter={() => setHoveredCard(content.id)}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div className="flex items-center gap-2">
            {!!content.link_live ? LiveSvg : PlayerSVG}
            <span className="font-medium">
              {language === "ar" ? content.title.ar : content.title.en}
            </span>
          </div>
          <div className="flex gap-2">
            {content.link_live ? (
              <a
                href={
                  content.link_live.includes("http")
                    ? content.link_live
                    : `http://${content.link_live}`
                }
                target="_blank"
              >
                <Button
                  variant="ghost"
                  size="sm"
                  className="text-primary"
                  disabled={!content.link_live && !content.video}
                >
                  {t.watch}
                </Button>
              </a>
            ) : (
              <Button
                variant="ghost"
                size="sm"
                className="text-primary"
                onClick={() =>
                  setVideoData((prev) => ({
                    ...prev,
                    url: content.video,
                    title: content.title[language],
                    description: content.description[language],
                    live: content.link_live,
                  }))
                }
                disabled={!content.link_live && !content.video}
              >
                {t.watch}
              </Button>
            )}

            {isTeacher && (
              <AnimatePresence>
                {hoveredCard === content.id && (
                  <>
                    <motion.div
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -10 }}
                      transition={{ duration: 0.2 }}
                    >
                      <DrawerEditContent
                        fetchContents={fetchContents}
                        item={content}
                      />
                    </motion.div>
                    <motion.div
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -10 }}
                      transition={{ duration: 0.2, delay: 0.05 }}
                    >
                      <DialogDeleteContent
                        item={content}
                        fetchContents={fetchContents}
                      />
                    </motion.div>
                  </>
                )}
              </AnimatePresence>
            )}
          </div>
        </div>
      ))}
      {isTeacher && <DrawerAddContent fetchContents={fetchContents} />}
    </div>
  );
}
